export const Bosses = [
    ['Larry Jr.', JSON.stringify({
      id: '19',
      subtype: '0',
      variant: '0',
    })],
    ['The Hollow', JSON.stringify({
      id: '19',
      subtype: '0',
      variant: '1',
    })],
    ['Monstro', JSON.stringify({
      id: '20',
      subtype: '0',
      variant: '0',
    })],
    ['Chub', JSON.stringify({
      id: '28',
      subtype: '0',
      variant: '0',
    })],
    ['C.H.A.D.', JSON.stringify({
      id: '28',
      subtype: '0',
      variant: '1',
    })],
    ['The Carrion Queen', JSON.stringify({
      id: '28',
      subtype: '0',
      variant: '2',
    })],
    ['Gurdy', JSON.stringify({
      id: '36',
      subtype: '0',
      variant: '0',
    })],
    ['Ultra Pride Baby', JSON.stringify({
      id: '38',
      subtype: '0',
      variant: '2',
    })],
    ['Monstro II', JSON.stringify({
      id: '43',
      subtype: '0',
      variant: '0',
    })],
    ['Gish', JSON.stringify({
      id: '43',
      subtype: '0',
      variant: '1',
    })],
    ['Mom', JSON.stringify({
      id: '45',
      subtype: '0',
      variant: '0',
    })],
    ['Sloth', JSON.stringify({
      id: '46',
      subtype: '0',
      variant: '0',
    })],
    ['Super Sloth', JSON.stringify({
      id: '46',
      subtype: '0',
      variant: '1',
    })],
    ['Ultra Pride', JSON.stringify({
      id: '46',
      subtype: '0',
      variant: '2',
    })],
    ['Lust', JSON.stringify({
      id: '47',
      subtype: '0',
      variant: '0',
    })],
    ['Super Lust', JSON.stringify({
      id: '47',
      subtype: '0',
      variant: '1',
    })],
    ['Wrath', JSON.stringify({
      id: '48',
      subtype: '0',
      variant: '0',
    })],
    ['Super Wrath', JSON.stringify({
      id: '48',
      subtype: '0',
      variant: '1',
    })],
    ['Gluttony', JSON.stringify({
      id: '49',
      subtype: '0',
      variant: '0',
    })],
    ['Super Gluttony', JSON.stringify({
      id: '49',
      subtype: '0',
      variant: '1',
    })],
    ['Greed', JSON.stringify({
      id: '50',
      subtype: '0',
      variant: '0',
    })],
    ['Super Greed', JSON.stringify({
      id: '50',
      subtype: '0',
      variant: '1',
    })],
    ['Envy', JSON.stringify({
      id: '51',
      subtype: '0',
      variant: '0',
    })],
    ['Envy (big)', JSON.stringify({
      id: '51',
      subtype: '0',
      variant: '10',
    })],
    ['Envy (medium)', JSON.stringify({
      id: '51',
      subtype: '0',
      variant: '20',
    })],
    ['Envy (small)', JSON.stringify({
      id: '51',
      subtype: '0',
      variant: '30',
    })],
    ['Super Envy', JSON.stringify({
      id: '51',
      subtype: '0',
      variant: '1',
    })],
    ['Super Envy (big)', JSON.stringify({
      id: '51',
      subtype: '0',
      variant: '11',
    })],
    ['Super Envy (medium)', JSON.stringify({
      id: '51',
      subtype: '0',
      variant: '21',
    })],
    ['Super Envy (small)', JSON.stringify({
      id: '51',
      subtype: '0',
      variant: '31',
    })],
    ['Pride', JSON.stringify({
      id: '52',
      subtype: '0',
      variant: '0',
    })],
    ['Super Pride', JSON.stringify({
      id: '52',
      subtype: '0',
      variant: '1',
    })],
    ['Pin', JSON.stringify({
      id: '62',
      subtype: '0',
      variant: '0',
    })],
    ['Scolex', JSON.stringify({
      id: '62',
      subtype: '0',
      variant: '1',
    })],
    ['The Frail', JSON.stringify({
      id: '62',
      subtype: '0',
      variant: '2',
    })],
    ['Famine', JSON.stringify({
      id: '63',
      subtype: '0',
      variant: '0',
    })],
    ['Pestilence', JSON.stringify({
      id: '64',
      subtype: '0',
      variant: '0',
    })],
    ['War', JSON.stringify({
      id: '65',
      subtype: '0',
      variant: '0',
    })],
    ['Conquest', JSON.stringify({
      id: '65',
      subtype: '0',
      variant: '1',
    })],
    ['War without horse', JSON.stringify({
      id: '65',
      subtype: '0',
      variant: '10',
    })],
    ['Death', JSON.stringify({
      id: '66',
      subtype: '0',
      variant: '0',
    })],
    ['Death Horse', JSON.stringify({
      id: '66',
      subtype: '0',
      variant: '20',
    })],
    ['Death without horse', JSON.stringify({
      id: '66',
      subtype: '0',
      variant: '30',
    })],
    ['The Duke of Flies', JSON.stringify({
      id: '67',
      subtype: '0',
      variant: '0',
    })],
    ['The Husk', JSON.stringify({
      id: '67',
      subtype: '0',
      variant: '1',
    })],
    ['Peep', JSON.stringify({
      id: '68',
      subtype: '0',
      variant: '0',
    })],
    ['The Bloat', JSON.stringify({
      id: '68',
      subtype: '0',
      variant: '1',
    })],
    ['Loki', JSON.stringify({
      id: '69',
      subtype: '0',
      variant: '0',
    })],
    ['Lokii', JSON.stringify({
      id: '69',
      subtype: '0',
      variant: '1',
    })],
    ['Fistula', JSON.stringify({
      id: '71',
      subtype: '0',
      variant: '0',
    })],
    ['Teratoma', JSON.stringify({
      id: '71',
      subtype: '0',
      variant: '1',
    })],
    ['Fistula Medium', JSON.stringify({
      id: '72',
      subtype: '0',
      variant: '0',
    })],
    ['Teratoma Medium', JSON.stringify({
      id: '72',
      subtype: '0',
      variant: '1',
    })],
    ['Fistula Small', JSON.stringify({
      id: '73',
      subtype: '0',
      variant: '0',
    })],
    ['Teratoma Small', JSON.stringify({
      id: '73',
      subtype: '0',
      variant: '1',
    })],
    ['Blastocyst', JSON.stringify({
      id: '74',
      subtype: '0',
      variant: '0',
    })],
    ['Blastocyst Medium', JSON.stringify({
      id: '75',
      subtype: '0',
      variant: '0',
    })],
    ['Blastocyst Small', JSON.stringify({
      id: '76',
      subtype: '0',
      variant: '0',
    })],
    ['Mom\'s Heart', JSON.stringify({
      id: '78',
      subtype: '0',
      variant: '0',
    })],
    ['It Lives', JSON.stringify({
      id: '78',
      subtype: '0',
      variant: '1',
    })],
    ['Gemini', JSON.stringify({
      id: '79',
      subtype: '0',
      variant: '0',
    })],
    ['Steven', JSON.stringify({
      id: '79',
      subtype: '0',
      variant: '1',
    })],
    ['The Blighted Ovum', JSON.stringify({
      id: '79',
      subtype: '0',
      variant: '2',
    })],
    ['The Fallen', JSON.stringify({
      id: '81',
      subtype: '0',
      variant: '0',
    })],
    ['Krampus', JSON.stringify({
      id: '81',
      subtype: '0',
      variant: '1',
    })],
    ['Headless Horseman', JSON.stringify({
      id: '82',
      subtype: '0',
      variant: '0',
    })],
    ['Satan', JSON.stringify({
      id: '84',
      subtype: '0',
      variant: '0',
    })],
    ['Satan Stomp', JSON.stringify({
      id: '84',
      subtype: '0',
      variant: '10',
    })],
    ['Mask of Infamy', JSON.stringify({
      id: '97',
      subtype: '0',
      variant: '0',
    })],
    ['Heart of Infamy', JSON.stringify({
      id: '98',
      subtype: '0',
      variant: '0',
    })],
    ['Gurdy Jr.', JSON.stringify({
      id: '99',
      subtype: '0',
      variant: '0',
    })],
    ['Widow', JSON.stringify({
      id: '100',
      subtype: '0',
      variant: '0',
    })],
    ['The Wretched', JSON.stringify({
      id: '100',
      subtype: '0',
      variant: '1',
    })],
    ['Daddy Long Legs', JSON.stringify({
      id: '101',
      subtype: '0',
      variant: '0',
    })],
    ['Triachnid', JSON.stringify({
      id: '101',
      subtype: '0',
      variant: '1',
    })],
    ['Isaac', JSON.stringify({
      id: '102',
      subtype: '0',
      variant: '0',
    })],
    ['???', JSON.stringify({
      id: '102',
      subtype: '0',
      variant: '1',
    })],
    ['??? (Alt)', JSON.stringify({
      id: '102',
      subtype: '0',
      variant: '2',
    })],
    ['Gurgling (boss)', JSON.stringify({
      id: '237',
      subtype: '0',
      variant: '1',
    })],
    ['Turdling', JSON.stringify({
      id: '237',
      subtype: '0',
      variant: '2',
    })],
    ['Haunt', JSON.stringify({
      id: '260',
      subtype: '0',
      variant: '0',
    })],
    ['Dingle', JSON.stringify({
      id: '261',
      subtype: '0',
      variant: '0',
    })],
    ['Dangle', JSON.stringify({
      id: '261',
      subtype: '0',
      variant: '1',
    })],
    ['Mega Maw', JSON.stringify({
      id: '262',
      subtype: '0',
      variant: '0',
    })],
    ['The Gate', JSON.stringify({
      id: '263',
      subtype: '0',
      variant: '0',
    })],
    ['Mega Fatty', JSON.stringify({
      id: '264',
      subtype: '0',
      variant: '0',
    })],
    ['The Cage', JSON.stringify({
      id: '265',
      subtype: '0',
      variant: '0',
    })],
    ['Mama Gurdy', JSON.stringify({
      id: '266',
      subtype: '0',
      variant: '0',
    })],
    ['Dark One', JSON.stringify({
      id: '267',
      subtype: '0',
      variant: '0',
    })],
    ['The Adversary', JSON.stringify({
      id: '268',
      subtype: '0',
      variant: '0',
    })],
    ['Polycephalus', JSON.stringify({
      id: '269',
      subtype: '0',
      variant: '0',
    })],
    ['Mr. Fred', JSON.stringify({
      id: '270',
      subtype: '0',
      variant: '0',
    })],
    ['Uriel', JSON.stringify({
      id: '271',
      subtype: '0',
      variant: '0',
    })],
    ['Fallen Uriel', JSON.stringify({
      id: '271',
      subtype: '0',
      variant: '1',
    })],
    ['Gabriel', JSON.stringify({
      id: '272',
      subtype: '0',
      variant: '0',
    })],
    ['Fallen Gabriel', JSON.stringify({
      id: '272',
      subtype: '0',
      variant: '1',
    })],
    ['The Lamb', JSON.stringify({
      id: '273',
      subtype: '0',
      variant: '0',
    })],
    ['Lamb Body', JSON.stringify({
      id: '273',
      subtype: '0',
      variant: '10',
    })],
    ['Mega Satan', JSON.stringify({
      id: '274',
      subtype: '0',
      variant: '0',
    })],
    ['Mega Satan 2', JSON.stringify({
      id: '275',
      subtype: '0',
      variant: '0',
    })],
    ['The Stain', JSON.stringify({
      id: '401',
      subtype: '0',
      variant: '0',
    })],
    ['Brownie', JSON.stringify({
      id: '402',
      subtype: '0',
      variant: '0',
    })],
    ['The Forsaken', JSON.stringify({
      id: '403',
      subtype: '0',
      variant: '0',
    })],
    ['Little Horn', JSON.stringify({
      id: '404',
      subtype: '0',
      variant: '0',
    })],
    ['Rag Man', JSON.stringify({
      id: '405',
      subtype: '0',
      variant: '0',
    })],
    ['Ultra Greed', JSON.stringify({
      id: '406',
      subtype: '0',
      variant: '0',
    })],
    ['Ultra Greedier', JSON.stringify({
      id: '406',
      subtype: '0',
      variant: '1',
    })],
    ['Hush', JSON.stringify({
      id: '407',
      subtype: '0',
      variant: '0',
    })],
    ['Hush (Skinless)', JSON.stringify({
      id: '408',
      subtype: '0',
      variant: '0',
    })],
    ['Rag Mega', JSON.stringify({
      id: '409',
      subtype: '0',
      variant: '0',
    })],
    ['Sisters Vis', JSON.stringify({
      id: '410',
      subtype: '0',
      variant: '0',
    })],
    ['Big Horn', JSON.stringify({
      id: '411',
      subtype: '0',
      variant: '0',
    })],
    ['Small Hole', JSON.stringify({
      id: '411',
      subtype: '0',
      variant: '1',
    })],
    ['Big Hole', JSON.stringify({
      id: '411',
      subtype: '0',
      variant: '2',
    })],
    ['Delirium', JSON.stringify({
      id: '412',
      subtype: '0',
      variant: '0',
    })],
    ['The Matriarch', JSON.stringify({
      id: '413',
      subtype: '0',
      variant: '0',
    })],
    ['Tuff Twin', JSON.stringify({
      id: '19',
      subtype: '0',
      variant: '2',
    })],
    ['The Shell', JSON.stringify({
      id: '19',
      subtype: '0',
      variant: '3',
    })],
    ['Wormwood', JSON.stringify({
      id: '62',
      subtype: '0',
      variant: '3',
    })],
    ['The Pile', JSON.stringify({
      id: '269',
      subtype: '0',
      variant: '1',
    })],
    ['Dark Esau', JSON.stringify({
      id: '866',
      subtype: '0',
      variant: '0',
    })],
    ['Mother\'s Shadow', JSON.stringify({
      id: '867',
      subtype: '0',
      variant: '0',
    })],
    ['Reap Creep', JSON.stringify({
      id: '900',
      subtype: '0',
      variant: '0',
    })],
    ['Lil Blub', JSON.stringify({
      id: '901',
      subtype: '0',
      variant: '0',
    })],
    ['Rainmaker', JSON.stringify({
      id: '902',
      subtype: '0',
      variant: '0',
    })],
    ['The Visage', JSON.stringify({
      id: '903',
      subtype: '0',
      variant: '0',
    })],
    ['Siren', JSON.stringify({
      id: '904',
      subtype: '0',
      variant: '0',
    })],
    ['The Heretic', JSON.stringify({
      id: '905',
      subtype: '0',
      variant: '0',
    })],
    ['Hornfel', JSON.stringify({
      id: '906',
      subtype: '0',
      variant: '0',
    })],
    ['Great Gideon', JSON.stringify({
      id: '907',
      subtype: '0',
      variant: '0',
    })],
    ['Great Gideon (defeated)', JSON.stringify({
      id: '907',
      subtype: '1',
      variant: '0',
    })],
    ['Baby Plum', JSON.stringify({
      id: '908',
      subtype: '0',
      variant: '0',
    })],
    ['The Scourge', JSON.stringify({
      id: '909',
      subtype: '0',
      variant: '0',
    })],
    ['Chimera', JSON.stringify({
      id: '910',
      subtype: '0',
      variant: '0',
    })],
    ['Rotgut', JSON.stringify({
      id: '911',
      subtype: '0',
      variant: '0',
    })],
    ['Mother', JSON.stringify({
      id: '912',
      subtype: '0',
      variant: '0',
    })],
    ['Mother 2', JSON.stringify({
      id: '912',
      subtype: '0',
      variant: '10',
    })],
    ['Mother Worm', JSON.stringify({
      id: '912',
      subtype: '0',
      variant: '30',
    })],
    ['Mother Ball', JSON.stringify({
      id: '912',
      subtype: '0',
      variant: '100',
    })],
    ['Min Min', JSON.stringify({
      id: '913',
      subtype: '0',
      variant: '0',
    })],
    ['Clog', JSON.stringify({
      id: '914',
      subtype: '0',
      variant: '0',
    })],
    ['Singe', JSON.stringify({
      id: '915',
      subtype: '0',
      variant: '0',
    })],
    ['Bumbino', JSON.stringify({
      id: '916',
      subtype: '0',
      variant: '0',
    })],
    ['Colostomia', JSON.stringify({
      id: '917',
      subtype: '0',
      variant: '0',
    })],
    ['Turdlet', JSON.stringify({
      id: '918',
      subtype: '0',
      variant: '0',
    })],
    ['Raglich', JSON.stringify({
      id: '919',
      subtype: '0',
      variant: '0',
    })],
    ['Horny Boys', JSON.stringify({
      id: '920',
      subtype: '0',
      variant: '0',
    })],
    ['Clutch', JSON.stringify({
      id: '921',
      subtype: '0',
      variant: '0',
    })],
    ['Dogma', JSON.stringify({
      id: '950',
      subtype: '0',
      variant: '0',
    })],
    ['Ultra Famine', JSON.stringify({
      id: '951',
      subtype: '0',
      variant: '10',
    })],
    ['Ultra Pestilence', JSON.stringify({
      id: '951',
      subtype: '0',
      variant: '20',
    })],
    ['Ultra War', JSON.stringify({
      id: '951',
      subtype: '0',
      variant: '30',
    })],
    ['Ultra Death', JSON.stringify({
      id: '951',
      subtype: '0',
      variant: '40',
    })],
    ['The Beast', JSON.stringify({
      id: '951',
      subtype: '0',
      variant: '0',
    })],
  ]
  